<ion-app appNoRightClick>
  <app-side-navigation *ngIf="!isVendor"></app-side-navigation>
  <vendor-side-navigation *ngIf="isVendor"></vendor-side-navigation>
  <ion-router-outlet id="main-content"></ion-router-outlet>
  <app-co-pilot *ngIf="copilot"></app-co-pilot>
</ion-app>